var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNaira2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 37,
    viewBox: "0 0 34 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.79233 22.0423H30.0261M2.79233 14.1H30.0261H2.79233Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.06003 32.1755C3.06003 33.5378 4.14732 34.6421 5.4886 34.6421C6.82985 34.6421 7.91717 33.5378 7.91717 32.1755H3.06003ZM27.3314 4.24066C27.3314 2.87837 26.2441 1.774 24.9028 1.774C23.5615 1.774 22.4742 2.87837 22.4742 4.24066H27.3314ZM7.91717 32.1755V12.0125H3.06003V32.1755H7.91717ZM7.91717 12.0125L18.5061 27.2488L22.4742 24.4037L11.8853 9.16748L7.91717 12.0125ZM27.3314 24.4037V4.24066H22.4742V24.4037H27.3314ZM18.5061 27.2488C21.239 31.1811 27.3314 29.2172 27.3314 24.4037H22.4742L18.5061 27.2488ZM7.91717 12.0125L11.8853 9.16748C9.15234 5.23504 3.06003 7.19903 3.06003 12.0125H7.91717Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaira2);
export default __webpack_public_path__ + "static/media/naira2.81e76b001cf40c29c7a7efa0f7e1633e.svg";
export { ForwardRef as ReactComponent };